import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { IAppSettingsState } from './app-settings-reducer';
import * as fromReducer from './app-settings-reducer';

const getAppSettingsState = createFeatureSelector<IAppSettingsState>('appSettings');

export const getAppSettings = createSelector(getAppSettingsState, fromReducer.getAppSettings);
export const getTheme = createSelector(getAppSettingsState, fromReducer.getTheme);
export const getLogo = createSelector(getAppSettingsState, fromReducer.getLogo);
export const getAppSettingsActionState = createSelector(
  getAppSettingsState,
  fromReducer.getAppSettingsActionState
);
